import React from 'react';
import { PhoneCountryCodeType } from '@bus/models';
import { TextInputFormField } from '../../../../../components/Fieldset/TextInputFormField';
import { PhoneNumberFormField } from '../../../../../components/Fieldset/PhoneNumberFormField';
import { SelectFormField } from '../../../../../components/Fieldset/SelectFormField';
import { createOptionsList } from '../../../../../services/common/miscUtils';

export const searchFormInputs = () => {
  return {
    legalName: () => (
      <TextInputFormField
        fieldName="legalName"
        labelTranslationKey="customerSearchModal:business:fields:legalName:label"
        placeholderTranslationKey="customerSearchModal:business:fields:legalName:placeholder"
      />
    ),
    email: () => (
      <TextInputFormField
        fieldName="email"
        labelTranslationKey="customerSearchModal:business:fields:email:label"
        placeholderTranslationKey="customerSearchModal:business:fields:email:placeholder"
        validateOnChange
      />
    ),
    countryCode: () => (
      <SelectFormField
        fieldName="countryCode"
        labelTranslationKey="customerSearchModal:business:fields:countryCode:label"
        optionList={createOptionsList(PhoneCountryCodeType, 'customerSearchModal:business', 'countryCode')}
      />
    ),
    mobileNumber: () => (
      <PhoneNumberFormField
        fieldName="mobileNumber"
        labelTranslationKey="customerSearchModal:business:fields:mobileNumber:label"
        placeholderTranslationKey="customerSearchModal:business:fields:mobileNumber:placeholder"
        type="mobile"
      />
    ),
  };
};
